export const LOGO_MAKER_TAG = {
    name: 'logo maker',
    slug: 'logo-maker',
    formattedClassification: {
        type: 'customUrl',
        key: 'logo-maker',
    },
};
export const LOGO_DESIGN_SUBCATEGORY_ID = 49;
